import { render, staticRenderFns } from "./PageConfiguration.vue?vue&type=template&id=26a71b5a&scoped=true"
import script from "./PageConfiguration.vue?vue&type=script&lang=js"
export * from "./PageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PageConfiguration.vue?vue&type=style&index=0&id=26a71b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a71b5a",
  null
  
)

export default component.exports